// extracted by mini-css-extract-plugin
module.exports = {"uploadBox":"DocumentsTraySection_uploadBox__3HsuZ","uploadBtn":"DocumentsTraySection_uploadBtn__2m0D2"};